import { render } from "./BaseLoader.vue?vue&type=template&id=37863b4e&ts=true"
import script from "./BaseLoader.vue?vue&type=script&lang=ts"
export * from "./BaseLoader.vue?vue&type=script&lang=ts"

import "./BaseLoader.vue?vue&type=style&index=0&id=37863b4e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__